import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Footer from "../../components/Footer";
import { HeaderOperator } from "../../components/Header";

const PublicLayout = ({ children }) => {
  const auth = useSelector((state) => state.auth);

  return (
    <section>
      <main className="dashboard-main m-0">
        <div className="navbar-header" style={{backgroundColor: '#22A6A8'}}>
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <Link to="/">
                <img src="/assets/images/logo.jpg" alt="site logo" width={40} />
              </Link>
            </div>
            <div className="col-auto">
              {isEmpty(auth) ? (
                <Link
                  to="/auth/login"
                  className="py-8 px-10 border border-primary-200 bg-primary-50 bg-hover-primary-100 radius-12"
                >
                  ورود به حساب کاربری
                </Link>
              ) : (
                <HeaderOperator />
              )}
            </div>
          </div>
        </div>

        <div>{children}</div>
      </main>
    </section>
  );
};

export default PublicLayout;
